module.exports = __webpack_public_path__ + "public/img/19.a4a9f6d6.png";